import React from 'react'
import {BugsnagErrorBoundary} from '@bugsnag/plugin-react'
import {fromJust} from '@freckle/maybe'
import {bugsnagClient} from '@freckle/classroom/ts/common/helpers/exception-handlers/bugsnag-client'

export const ErrorBoundary: BugsnagErrorBoundary = fromJust(
  bugsnagClient.getPlugin('react'),
  'We should be able to make an ErrorBoundary'
).createErrorBoundary(React)
